"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./IB7YUKH5.js";
import {
  PopoverContextProvider,
  PopoverScopedContextProvider
} from "./7H5KSHHF.js";
import {
  createStoreContext
} from "./3ORBWXWF.js";

// src/combobox/combobox-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useComboboxContext = ctx.useContext;
var useComboboxScopedContext = ctx.useScopedContext;
var useComboboxProviderContext = ctx.useProviderContext;
var ComboboxContextProvider = ctx.ContextProvider;
var ComboboxScopedContextProvider = ctx.ScopedContextProvider;
var ComboboxItemValueContext = createContext(
  void 0
);
var ComboboxItemCheckedContext = createContext(false);

export {
  useComboboxContext,
  useComboboxScopedContext,
  useComboboxProviderContext,
  ComboboxContextProvider,
  ComboboxScopedContextProvider,
  ComboboxItemValueContext,
  ComboboxItemCheckedContext
};
